import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AgentDashboard() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('projects');
  const [showProjectInitModal, setShowProjectInitModal] = useState(false);
  const [showAIChat, setShowAIChat] = useState(false);
  const [chatMessages, setChatMessages] = useState([
    {
      role: 'assistant',
      content: '您好！我是AI招标助手，我将通过对话的方式帮助您快速完成项目初始化。请告诉我您的项目基本情况，比如：项目名称、类型、预算等信息。您也可以自由描述，我会智能提取关键信息。'
    }
  ]);
  const [userInput, setUserInput] = useState('');

  const stats = [
    { label: '代理项目', value: '18', icon: 'ri-file-list-line', color: 'bg-cyan-500' },
    { label: '进行中', value: '12', icon: 'ri-time-line', color: 'bg-blue-500' },
    { label: '已完成', value: '89', icon: 'ri-checkbox-circle-line', color: 'bg-green-500' },
    { label: '服务客户', value: '45', icon: 'ri-user-line', color: 'bg-purple-500' }
  ];

  const projects = [
    {
      id: 1,
      name: '省道S218线改扩建工程施工总承包',
      code: 'JTT2024001',
      client: '省交通运输厅',
      budget: '¥8,500万',
      status: '招标中',
      bidders: 15,
      deadline: '2024-03-15',
      progress: 45
    },
    {
      id: 2,
      name: '国道G324线大桥建设工程',
      code: 'JTT2024002',
      client: '省交通运输厅',
      budget: '¥12,800万',
      status: '评标中',
      bidders: 18,
      deadline: '2024-03-08',
      progress: 70
    },
    {
      id: 3,
      name: '高速公路隧道照明系统升级改造',
      code: 'JTT2024003',
      client: '省交通运输厅',
      budget: '¥3,200万',
      status: '招标中',
      bidders: 12,
      deadline: '2024-03-20',
      progress: 35
    },
    {
      id: 4,
      name: '县道X156线路面大修工程',
      code: 'JTT2024004',
      client: '省交通运输厅',
      budget: '¥2,600万',
      status: '资格预审',
      bidders: 9,
      deadline: '2024-03-25',
      progress: 25
    }
  ];

  const recentActivities = [
    { id: 1, action: '项目DL2024001收到新投标文件', time: '15分钟前', icon: 'ri-file-add-line', color: 'text-cyan-600' },
    { id: 2, action: '完成项目DL2024002资格预审', time: '1小时前', icon: 'ri-checkbox-circle-line', color: 'text-green-600' },
    { id: 3, action: '组织项目DL2024003评标会议', time: '2小时前', icon: 'ri-team-line', color: 'text-blue-600' },
    { id: 4, action: '发布项目DL2024004招标公告', time: '4小时前', icon: 'ri-megaphone-line', color: 'text-orange-600' }
  ];

  const clients = [
    { name: '省高速公路管理局', projects: 8, status: '合作中' },
    { name: '市公路养护中心', projects: 5, status: '合作中' },
    { name: '省交通建设集团', projects: 12, status: '合作中' },
    { name: '市轨道交通公司', projects: 6, status: '合作中' }
  ];

  const handleSendMessage = () => {
    if (!userInput.trim()) return;

    // Add user message
    const newMessages = [
      ...chatMessages,
      { role: 'user', content: userInput }
    ];

    // Simulate AI response
    setTimeout(() => {
      const aiResponse = {
        role: 'assistant',
        content: '我已经理解了您的需求。让我为您总结一下：\n\n根据您的描述，我提取到以下关键信息：\n• 项目类型：公路工程\n• 预算规模：中大型项目\n• 关注重点：技术方案和施工质量\n\n我还需要了解一些细节：\n1. 项目的具体建设地点在哪里？\n2. 计划工期是多久？\n3. 资金来源是政府财政还是其他？\n\n您可以继续补充，或者点击下方"切换到表单模式"进行详细填写。'
      };
      setChatMessages([...newMessages, aiResponse]);
    }, 1000);

    setChatMessages(newMessages);
    setUserInput('');
  };

  const handleCreateProject = () => {
    setShowProjectInitModal(true);
    setShowAIChat(true);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <button onClick={() => navigate('/')} className="text-gray-600 hover:text-gray-900 cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-cyan-500 rounded-lg flex items-center justify-center">
                  <i className="ri-service-line text-xl text-white"></i>
                </div>
                <div>
                  <h1 className="text-xl font-bold text-gray-900">招标代理工作台</h1>
                  <p className="text-sm text-gray-500">专业招标代理服务机构</p>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button className="px-4 py-2 text-gray-600 hover:text-gray-900 whitespace-nowrap cursor-pointer">
                <i className="ri-notification-line text-xl"></i>
              </button>
              <button 
                onClick={handleCreateProject}
                className="px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-add-line mr-2"></i>
                智能创建项目
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="p-6">
        {/* Core Function Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          <div 
            onClick={handleCreateProject}
            className="bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-xl shadow-lg p-6 text-white hover:shadow-2xl transition-all cursor-pointer transform hover:-translate-y-1"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-file-add-line text-2xl"></i>
              </div>
              <i className="ri-arrow-right-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">智能项目初始化</h3>
            <p className="text-cyan-100 text-sm">AI辅助采集项目信息，自动推荐标准范本</p>
          </div>

          <div 
            onClick={() => navigate('/agent/document-editor')}
            className="bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl shadow-lg p-6 text-white hover:shadow-2xl transition-all cursor-pointer transform hover:-translate-y-1"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-edit-box-line text-2xl"></i>
              </div>
              <i className="ri-arrow-right-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">招标文件编制</h3>
            <p className="text-blue-100 text-sm">AI辅助生成招标公告、评标办法等核心内容</p>
          </div>

          <div 
            onClick={() => navigate('/agent/knowledge-base')}
            className="bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl shadow-lg p-6 text-white hover:shadow-2xl transition-all cursor-pointer transform hover:-translate-y-1"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-book-line text-2xl"></i>
              </div>
              <i className="ri-arrow-right-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">智能知识库</h3>
            <p className="text-purple-100 text-sm">法规库、范本库、常见问题库一键检索</p>
          </div>

          <div 
            onClick={() => navigate('/agent/risk-check')}
            className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl shadow-lg p-6 text-white hover:shadow-2xl transition-all cursor-pointer transform hover:-translate-y-1"
          >
            <div className="flex items-center justify-between mb-4">
              <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <i className="ri-arrow-right-line text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold mb-2">智能审查预警</h3>
            <p className="text-orange-100 text-sm">合规性扫描、风险预警、矛盾性检查</p>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm p-6 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between mb-4">
                <div className={`w-12 h-12 ${stat.color} rounded-lg flex items-center justify-center`}>
                  <i className={`${stat.icon} text-2xl text-white`}></i>
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</div>
              <div className="text-sm text-gray-500">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-sm">
              <div className="border-b border-gray-200 px-6">
                <div className="flex space-x-8">
                  {[
                    { id: 'projects', label: '代理项目', icon: 'ri-folder-line' },
                    { id: 'clients', label: '客户管理', icon: 'ri-user-line' },
                    { id: 'documents', label: '文件管理', icon: 'ri-file-text-line' }
                  ].map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors ${
                        activeTab === tab.id
                          ? 'border-cyan-600 text-cyan-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      <i className={`${tab.icon} mr-2`}></i>
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="p-6">
                {activeTab === 'projects' && (
                  <div className="space-y-4">
                    {projects.map((project) => (
                      <div key={project.id} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                        <div className="flex items-start justify-between mb-4">
                          <div className="flex-1">
                            <div className="flex items-center space-x-3 mb-2">
                              <h3 className="text-lg font-bold text-gray-900">{project.name}</h3>
                              <span className={`px-3 py-1 text-xs font-semibold rounded-full whitespace-nowrap ${
                                project.status === '招标中' ? 'bg-cyan-100 text-cyan-700' :
                                project.status === '资格预审' ? 'bg-blue-100 text-blue-700' :
                                'bg-orange-100 text-orange-700'
                              }`}>
                                {project.status}
                              </span>
                            </div>
                            <div className="flex items-center space-x-6 text-sm text-gray-600">
                              <span><i className="ri-price-tag-3-line mr-1"></i>编号: {project.code}</span>
                              <span><i className="ri-building-line mr-1"></i>委托方: {project.client}</span>
                              <span><i className="ri-money-cny-circle-line mr-1"></i>预算: {project.budget}</span>
                            </div>
                          </div>
                        </div>
                        <div className="mb-4">
                          <div className="flex items-center justify-between text-sm mb-2">
                            <span className="text-gray-600">项目进度</span>
                            <span className="font-semibold text-gray-900">{project.progress}%</span>
                          </div>
                          <div className="w-full bg-gray-200 rounded-full h-2">
                            <div className="bg-cyan-600 h-2 rounded-full transition-all" style={{ width: `${project.progress}%` }}></div>
                          </div>
                        </div>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-4 text-sm text-gray-600">
                            <span><i className="ri-user-line mr-1"></i>投标企业: {project.bidders}家</span>
                            <span><i className="ri-calendar-line mr-1"></i>截止: {project.deadline}</span>
                          </div>
                          <div className="flex items-center space-x-2">
                            <button className="px-4 py-2 text-cyan-600 border border-cyan-600 rounded-lg hover:bg-cyan-50 whitespace-nowrap cursor-pointer">
                              查看详情
                            </button>
                            <button className="px-4 py-2 bg-cyan-600 text-white rounded-lg hover:bg-cyan-700 whitespace-nowrap cursor-pointer">
                              管理项目
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'clients' && (
                  <div className="space-y-3">
                    {clients.map((client, index) => (
                      <div key={index} className="border border-gray-200 rounded-lg p-5 hover:shadow-md transition-shadow">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-4">
                            <div className="w-12 h-12 bg-cyan-100 rounded-lg flex items-center justify-center">
                              <i className="ri-building-line text-2xl text-cyan-600"></i>
                            </div>
                            <div>
                              <h4 className="font-bold text-gray-900">{client.name}</h4>
                              <p className="text-sm text-gray-600">代理项目: {client.projects}个</p>
                            </div>
                          </div>
                          <div className="flex items-center space-x-3">
                            <span className="px-3 py-1 bg-green-100 text-green-700 text-xs font-semibold rounded-full whitespace-nowrap">
                              {client.status}
                            </span>
                            <button className="px-4 py-2 text-cyan-600 border border-cyan-600 rounded-lg hover:bg-cyan-50 whitespace-nowrap cursor-pointer">
                              查看详情
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {activeTab === 'documents' && (
                  <div>
                    <div className="text-center py-12">
                      <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                        <i className="ri-file-text-line text-4xl text-gray-400"></i>
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">文件管理</h3>
                      <p className="text-gray-600">管理所有招标文件和资料</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6">
            {/* Recent Activities */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">最近动态</h3>
              <div className="space-y-4">
                {recentActivities.map((activity) => (
                  <div key={activity.id} className="flex items-start space-x-3">
                    <div className={`w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0`}>
                      <i className={`${activity.icon} ${activity.color}`}></i>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm text-gray-900 font-medium">{activity.action}</p>
                      <p className="text-xs text-gray-500">{activity.time}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Quick Actions */}
            <div className="bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-xl shadow-sm p-6 text-white">
              <h3 className="text-lg font-bold mb-4">快捷操作</h3>
              <div className="space-y-3">
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-add-circle-line mr-2"></i>
                  新建代理项目
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-megaphone-line mr-2"></i>
                  发布招标公告
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-file-list-line mr-2"></i>
                  编制招标文件
                </button>
                <button className="w-full px-4 py-3 bg-white/20 hover:bg-white/30 rounded-lg text-left whitespace-nowrap cursor-pointer transition-colors">
                  <i className="ri-team-line mr-2"></i>
                  组织评标会议
                </button>
              </div>
            </div>

            {/* Service Info */}
            <div className="bg-white rounded-xl shadow-sm p-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">服务范围</h3>
              <div className="space-y-3 text-sm">
                <div className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-fill text-cyan-600 mt-0.5"></i>
                  <span className="text-gray-700">招标文件编制</span>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-fill text-cyan-600 mt-0.5"></i>
                  <span className="text-gray-700">招标公告发布</span>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-fill text-cyan-600 mt-0.5"></i>
                  <span className="text-gray-700">资格预审组织</span>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-fill text-cyan-600 mt-0.5"></i>
                  <span className="text-gray-700">开标评标组织</span>
                </div>
                <div className="flex items-start space-x-2">
                  <i className="ri-checkbox-circle-fill text-cyan-600 mt-0.5"></i>
                  <span className="text-gray-700">中标结果公示</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Project Initialization Modal */}
      {showProjectInitModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl max-w-6xl w-full max-h-[90vh] overflow-hidden flex flex-col">
            <div className="sticky top-0 bg-white border-b border-gray-200 px-8 py-6 flex items-center justify-between">
              <div>
                <h2 className="text-2xl font-bold text-gray-900">智能项目初始化</h2>
                <p className="text-sm text-gray-500 mt-1">AI将根据您的输入自动推荐最合适的招标文件范本</p>
              </div>
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => setShowAIChat(!showAIChat)}
                  className={`px-4 py-2 rounded-lg whitespace-nowrap cursor-pointer transition-colors ${
                    showAIChat
                      ? 'bg-cyan-600 text-white hover:bg-cyan-700'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <i className={`${showAIChat ? 'ri-chat-3-fill' : 'ri-chat-3-line'} mr-2`}></i>
                  {showAIChat ? '切换智能填写模式' : '切换到对话'}
                </button>
                <button 
                  onClick={() => {
                    setShowProjectInitModal(false);
                    setShowAIChat(false);
                  }}
                  className="w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-hidden flex">
              {/* AI Chat Mode */}
              {showAIChat && (
                <div className="flex-1 flex flex-col bg-gradient-to-br from-cyan-50 to-blue-50">
                  {/* Chat Header */}
                  <div className="px-8 py-4 bg-white/80 backdrop-blur-sm border-b border-gray-200">
                    <div className="flex items-center space-x-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-xl flex items-center justify-center">
                        <i className="ri-robot-line text-2xl text-white"></i>
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-900">AI招标助手</h3>
                        <p className="text-sm text-gray-500">智能对话，快速采集项目信息</p>
                      </div>
                    </div>
                  </div>

                  {/* Chat Messages */}
                  <div className="flex-1 overflow-y-auto px-8 py-6 space-y-4">
                    {chatMessages.map((message, index) => (
                      <div
                        key={index}
                        className={`flex ${message.role === 'user' ? 'justify-end' : 'justify-start'}`}
                      >
                        <div
                          className={`max-w-[80%] rounded-2xl px-6 py-4 ${
                            message.role === 'user'
                              ? 'bg-cyan-600 text-white'
                              : 'bg-white shadow-sm border border-gray-200'
                          }`}
                        >
                          {message.role === 'assistant' && (
                            <div className="flex items-center space-x-2 mb-2">
                              <div className="w-6 h-6 bg-gradient-to-br from-cyan-500 to-blue-500 rounded-full flex items-center justify-center">
                                <i className="ri-sparkling-line text-xs text-white"></i>
                              </div>
                              <span className="text-xs font-semibold text-gray-500">AI助手</span>
                            </div>
                          )}
                          <div className={`whitespace-pre-wrap ${message.role === 'user' ? 'text-white' : 'text-gray-800'}`}>
                            {message.content}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Chat Input */}
                  <div className="px-8 py-6 bg-white border-t border-gray-200">
                    <div className="flex items-end space-x-3">
                      <div className="flex-1">
                        <textarea
                          value={userInput}
                          onChange={(e) => setUserInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter' && !e.shiftKey) {
                              e.preventDefault();
                              handleSendMessage();
                            }
                          }}
                          placeholder="描述您的项目需求，例如：我们要建设一条连接市区和机场的高速公路，预算约5亿元..."
                          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-cyan-500 focus:border-transparent resize-none"
                          rows={3}
                          maxLength={500}
                        />
                        <div className="flex items-center justify-between mt-2">
                          <span className="text-xs text-gray-500">
                            {userInput.length}/500 字符 | 按 Enter 发送，Shift+Enter 换行
                          </span>
                          <div className="flex items-center space-x-2">
                            <button className="px-3 py-1 text-sm text-gray-600 hover:text-cyan-600 cursor-pointer">
                              <i className="ri-attachment-line mr-1"></i>
                              上传文件
                            </button>
                          </div>
                        </div>
                      </div>
                      <button
                        onClick={handleSendMessage}
                        disabled={!userInput.trim()}
                        className="px-6 py-3 bg-gradient-to-r from-cyan-600 to-blue-600 text-white rounded-xl hover:from-cyan-700 hover:to-blue-700 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer flex items-center space-x-2"
                      >
                        <i className="ri-send-plane-fill"></i>
                        <span>发送</span>
                      </button>
                    </div>

                    {/* Quick Suggestions */}
                    <div className="mt-4 flex flex-wrap gap-2">
                      <span className="text-xs text-gray-500">快速输入：</span>
                      {[
                        '公路工程项目',
                        '桥梁建设项目',
                        '隧道工程',
                        'EPC总承包',
                        '市政道路改造'
                      ].map((suggestion, idx) => (
                        <button
                          key={idx}
                          onClick={() => setUserInput(suggestion)}
                          className="px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-full text-xs cursor-pointer transition-colors"
                        >
                          {suggestion}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* Form Mode */}
              {!showAIChat && (
                <div className="flex-1 overflow-y-auto p-8">
                  {/* Project Overview */}
                  <div className="mb-8">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                      <div className="w-8 h-8 bg-cyan-100 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-file-list-line text-cyan-600"></i>
                      </div>
                      项目概况
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">项目名称</label>
                        <input 
                          type="text" 
                          placeholder="例如：某市高速公路建设工程"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">招标人</label>
                        <input 
                          type="text" 
                          placeholder="例如：某市交通运输局"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">建设地点</label>
                        <input 
                          type="text" 
                          placeholder="例如：某省某市某区"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-semibold text-gray-700 mb-2">总投资（万元）</label>
                        <input 
                          type="number" 
                          placeholder="例如：50000"
                          className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-cyan-500 focus:border-transparent"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Bidding Scope */}
                  <div className="mb-8">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                      <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-compass-line text-blue-600"></i>
                      </div>
                      招标范围
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                      {['施工总承包', '设计', '监理', 'EPC总承包', '设备采购', '材料采购', '专业分包', '投资人招标', '项目实施机构', '其他'].map((item) => (
                        <label key={item} className="flex items-center space-x-2 p-3 border border-gray-300 rounded-lg hover:border-cyan-500 cursor-pointer transition-colors">
                          <input type="checkbox" className="w-4 h-4 text-cyan-600 rounded cursor-pointer" />
                          <span className="text-sm text-gray-700">{item}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Project Type */}
                  <div className="mb-8">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                      <div className="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-road-map-line text-purple-600"></i>
                      </div>
                      项目类型（交通工程专业分类）
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      {['公路工程', '桥梁工程', '隧道工程', '市政道路', '轨道交通', '港口码头', '机场工程', '交通设施', '水运工程', '其他'].map((item) => (
                        <label key={item} className="flex items-center space-x-2 p-3 border border-gray-300 rounded-lg hover:border-purple-500 cursor-pointer transition-colors">
                          <input type="radio" name="projectType" className="w-4 h-4 text-purple-600 cursor-pointer" />
                          <span className="text-sm text-gray-700">{item}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Core Requirements */}
                  <div className="mb-8">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                      <div className="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-focus-line text-orange-600"></i>
                      </div>
                      核心需求与关注点
                    </h3>
                    <div className="space-y-3">
                      <label className="flex items-center space-x-3 p-4 border border-gray-300 rounded-lg hover:border-orange-500 cursor-pointer transition-colors">
                        <input type="checkbox" className="w-5 h-5 text-orange-600 rounded cursor-pointer" />
                        <div>
                          <div className="font-semibold text-gray-900">最低价中标</div>
                          <div className="text-sm text-gray-500">采用经评审的最低投标价法</div>
                        </div>
                      </label>
                      <label className="flex items-center space-x-3 p-4 border border-gray-300 rounded-lg hover:border-orange-500 cursor-pointer transition-colors">
                        <input type="checkbox" className="w-5 h-5 text-orange-600 rounded cursor-pointer" />
                        <div>
                          <div className="font-semibold text-gray-900">重视技术方案</div>
                          <div className="text-sm text-gray-500">技术评分权重较高，注重施工组织设计</div>
                        </div>
                      </label>
                      <label className="flex items-center space-x-3 p-4 border border-gray-300 rounded-lg hover:border-orange-500 cursor-pointer transition-colors">
                        <input type="checkbox" className="w-5 h-5 text-orange-600 rounded cursor-pointer" />
                        <div>
                          <div className="font-semibold text-gray-900">品牌/工艺要求</div>
                          <div className="text-sm text-gray-500">对特定材料、设备品牌或施工工艺有要求</div>
                        </div>
                      </label>
                      <label className="flex items-center space-x-3 p-4 border border-gray-300 rounded-lg hover:border-orange-500 cursor-pointer transition-colors">
                        <input type="checkbox" className="w-5 h-5 text-orange-600 rounded cursor-pointer" />
                        <div>
                          <div className="font-semibold text-gray-900">企业资质与业绩</div>
                          <div className="text-sm text-gray-500">注重投标人的资质等级和类似项目经验</div>
                        </div>
                      </label>
                    </div>
                  </div>

                  {/* Special Risk Points */}
                  <div className="mb-8">
                    <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center">
                      <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center mr-3">
                        <i className="ri-alert-line text-red-600"></i>
                      </div>
                      特殊风险点（可选）
                    </h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                      {['高边坡支护', '跨线施工', '汛期施工', '地质条件复杂', '征地拆迁', '材料价格波动', '交通导行', '环保要求高', '其他'].map((item) => (
                        <label key={item} className="flex items-center space-x-2 p-3 border border-gray-300 rounded-lg hover:border-red-500 cursor-pointer transition-colors">
                          <input type="checkbox" className="w-4 h-4 text-red-600 rounded cursor-pointer" />
                          <span className="text-sm text-gray-700">{item}</span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* AI Recommendation Preview */}
                  <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-xl p-6 mb-6">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                        <i className="ri-sparkling-line text-2xl text-white"></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="text-lg font-bold text-gray-900 mb-2">AI智能推荐</h4>
                        <p className="text-gray-700 mb-4">根据您输入的项目信息，系统将自动推荐：</p>
                        <div className="space-y-2">
                          <div className="flex items-center space-x-2 text-sm">
                            <i className="ri-checkbox-circle-fill text-cyan-600"></i>
                            <span className="text-gray-700">最适合的招标文件标准范本</span>
                          </div>
                          <div className="flex items-center space-x-2 text-sm">
                            <i className="ri-checkbox-circle-fill text-cyan-600"></i>
                            <span className="text-gray-700">合理的评标方法和权重分配</span>
                          </div>
                          <div className="flex items-center space-x-2 text-sm">
                            <i className="ri-checkbox-circle-fill text-cyan-600"></i>
                            <span className="text-gray-700">相关技术规范和工艺要求</span>
                          </div>
                          <div className="flex items-center space-x-2 text-sm">
                            <i className="ri-checkbox-circle-fill text-cyan-600"></i>
                            <span className="text-gray-700">针对性的专用合同条款</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="flex items-center justify-end space-x-4">
                    <button 
                      onClick={() => setShowProjectInitModal(false)}
                      className="px-6 py-3 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 whitespace-nowrap cursor-pointer"
                    >
                      取消
                    </button>
                    <button 
                      onClick={() => {
                        setShowProjectInitModal(false);
                        navigate('/agent/document-editor');
                      }}
                      className="px-6 py-3 bg-gradient-to-r from-cyan-600 to-blue-600 text-white rounded-lg hover:from-cyan-700 hover:to-blue-700 whitespace-nowrap cursor-pointer flex items-center space-x-2"
                    >
                      <i className="ri-sparkling-line"></i>
                      <span>生成招标文件</span>
                      <i className="ri-arrow-right-line"></i>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
